<template id="merge-contact-modal-template">
  <base-form :do="save" class="flex flex-col" id="merge-contact-modal">
    <div class="modal-body content">
      <div class="group fields">
        <div class="field-group">
          <div class="field-heading">
            <label>Organisatie A (blijft bestaan)&nbsp;</label>
          </div>
          <span class="block text-sm text-grey-darkest py-2">{{
            target.name
          }}</span>
        </div>

        <div class="field-group relative">
          <div class="field-heading">
            <label>Organisatie B (wordt samengevoegd in A)&nbsp;</label>
          </div>
          <input
            class="text"
            type="text"
            name="source_search"
            autocomplete="off"
            placeholder="Zoek een organisatie (min. 3 tekens)..."
            v-model="search"
            @input="onSearch"
          />
          <div
            class="absolute rounded z-30 bg-white border pin-r pin-l mt-1 overflow-y-auto"
            v-if="results.length"
            style="max-height: 160px"
          >
            <div class="px-2 py-2 text-sm text-grey-darker">
              <button
                type="button"
                v-for="contact in results"
                :key="contact.id"
                @click="selectSource(contact)"
                class="text-left inline-block w-full px-3 py-2 mt-1 hover:bg-grey-lighter rounded"
              >
                {{ contact.name }}
              </button>
            </div>
          </div>
          <transition name="slide">
            <span v-if="sourceError" class="block form-error text-xs">
              {{ sourceError }}
            </span>
          </transition>
        </div>

        <p class="text-sm text-grey-darker mt-4">
          Alle complexen/objecten en opdrachten van organisatie B worden
          overgezet naar organisatie A. Organisatie B wordt daarna verwijderd.
          Dit kan niet ongedaan worden gemaakt.
        </p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-tertiary btn-sm" @click="close">
        Annuleren
      </button>
      <button type="submit" class="btn btn-primary btn-sm" :disabled="isSaving">
        Samenvoegen
      </button>
    </div>
  </base-form>
</template>

<script>
import ContactService from '@/services/contact';
import BaseForm from '@/components/globals/BaseForm';

import { EventBus } from '@/event-bus';
import { mapMutations } from 'vuex';
import { HIDE_MODAL } from '@/store/mutations.types';

export default {
  name: 'MergeContactModal',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    BaseForm,
  },
  data() {
    return {
      target: {},
      source: null,
      search: '',
      results: [],
      sourceError: '',
      isSaving: false,
    };
  },
  created() {
    this.target = this.$store.state.modal.items.organization;
  },
  methods: {
    ...mapMutations('modal', {
      hide: HIDE_MODAL,
    }),
    close() {
      this.hide();
    },
    async onSearch() {
      this.source = null;
      this.sourceError = '';

      const keyword = this.search;
      if (keyword.length < 3) {
        return (this.results = []);
      }

      try {
        const { data: response } = await ContactService.search(keyword);
        // Ignore responses for an outdated keyword
        if (keyword !== this.search) return;
        this.results = response.data.filter(
          (contact) => contact.id !== this.target.id
        );
      } catch (e) {
        this.results = [];
      }
    },
    selectSource(contact) {
      this.source = contact;
      this.search = contact.name;
      this.results = [];
      this.sourceError = '';
    },
    async save() {
      if (!this.source) {
        this.sourceError = 'Selecteer organisatie B.';
        return;
      }

      const confirmed = confirm(
        `Weet u zeker dat u "${this.source.name}" wilt samenvoegen in "${this.target.name}"? ` +
          `"${this.source.name}" wordt daarna verwijderd.`
      );
      if (!confirmed) return;

      this.isSaving = true;
      try {
        await ContactService.merge(this.target.id, this.source.id);
        EventBus.$emit('contact-merged', this.source);
        this.close();
      } catch (error) {
        const details = error && error.data && error.data.details;
        if (details && details.source_id) {
          this.sourceError = details.source_id[0];
          return;
        }
        EventBus.$emit('contact-merge-failed');
        this.close();
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
